export { default as InitialSearchView } from './InitialSearchView';
